type LastUsedMap = Record<string, number>;

const readLastUsedMap = (storageKey: string): LastUsedMap => {
  try {
    const rawValue = localStorage.getItem(storageKey);
    if (!rawValue) return {};

    const parsed = JSON.parse(rawValue) as LastUsedMap;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const writeLastUsedMap = (storageKey: string, lastUsedMap: LastUsedMap) => {
  localStorage.setItem(storageKey, JSON.stringify(lastUsedMap));
};

export const markItemsAsLastUsed = (storageKey: string, itemKeys: string[]) => {
  if (itemKeys.length === 0) return;

  const lastUsedMap = readLastUsedMap(storageKey);
  const now = Date.now();

  itemKeys.forEach((itemKey, index) => {
    lastUsedMap[itemKey] = now - index;
  });

  writeLastUsedMap(storageKey, lastUsedMap);
};

export const sortItemsByLastUsed = <T>(items: T[], storageKey: string, getItemKey: (item: T) => string, getFallbackLabel: (item: T) => string) => {
  const lastUsedMap = readLastUsedMap(storageKey);

  return [...items].sort((left, right) => {
    const leftLastUsed = lastUsedMap[getItemKey(left)] ?? 0;
    const rightLastUsed = lastUsedMap[getItemKey(right)] ?? 0;

    if (leftLastUsed !== rightLastUsed) {
      return rightLastUsed - leftLastUsed;
    }

    return getFallbackLabel(left).localeCompare(getFallbackLabel(right));
  });
};
